import React, { useEffect, useReducer, useState } from "react";
import { Dialog, FormLabel, Button, Paper, DialogTitle, Divider, DialogContent, Container, TextField, Select, InputLabel, DialogActions, IconButton, Typography, } from "@mui/material"
import api from "../../services/api"
import makeStyles from "@mui/styles/makeStyles";
import { green } from "@mui/material/colors";
import { AttachFile, Delete } from "@mui/icons-material";
import { toast } from "react-toastify";

const useStyles = makeStyles(theme => ({
    root: {
        display: "flow-root",
        flexWrap: "wrap",
    },
    textField: {
        marginRight: theme.spacing(1),
        flex: 1,
    },

    btnWrapper: {
        position: "relative",
    },

    buttonProgress: {
        color: green[500],
        position: "absolute",
        top: "50%",
        left: "50%",
        marginTop: -12,
        marginLeft: -12,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    colorAdorment: {
        width: 20,
        height: 20,
    },
    ContentContainer: {
        margin: `4px`,
        marginTop: `8px`
    },
    wrapIcon: {
        verticalAlign: 'middle',
        display: 'inline-flex'
    },
    paper: { minWidth: "500px" },
}));

const EditCampanha = ({ open, onClose, cData }) => {

    const classes = useStyles();
    const [whatsData, setWhatsData] = useState([])
    const [filasData, setFilasData] = useState([])
    const [filaLocked, setFilaLocked] = useState(false)
    const [fila, setFila] = useState(``)
    const [whats, setWhats] = useState(``)
    const [campanha, setCampanha] = useState(``)
    const [tempoInicio, setTempoInicio] = useState(``)
    const [tempoFinal, setTempoFinal] = useState(``)
    const [dataInicio, setDataInicio] = useState(``)
    const [dataFinal, setDataFinal] = useState(``)
    const [msg,setMensagem] = useState(``)
    const [imagem,setImagem] = useState(``)
    const [nomeAnexo,setNomeAnexo] = useState(``)
    
    useEffect(() => {
        if(open === true){
            whatsData.forEach(i => {
                if (i.id == cData.idWhats) {
                    setFilasData(i.queues)
                    setFilaLocked(false)
                }
            })
            setFila(cData.idFila)
            setWhats(cData.idWhats)
            setCampanha(cData.name)
            setTempoInicio(cData.horarioInicial)
            setTempoFinal(cData.horarioFinal)
            setDataInicio(cData.dataInicial)
            setDataFinal(cData.dataFinal)
            setMensagem(cData.mensagem)
            setNomeAnexo(cData.imagem)
        }
    },[open])

    const onSelectFile = e => {
        setImagem(e.target.files[0])
        setNomeAnexo(e.target.files[0].name)
    }

    const handleClose = () => {
        onClose();
    };

    useEffect(() => {
        const getData = async () => {
            const { data } = await api.get("/whatsapp");
            setWhatsData(data)
        }
        getData()
    }, [])

    const handleWhats = (e) => {
        if (e.target.value == 0) {
            setFilasData([])
            setFilaLocked(true)
        }
        whatsData.forEach(i => {
            if (i.id == e.target.value) {
                setFilasData(i.queues)
                setFilaLocked(false)
            }
            setWhats(e.target.value)
        });
    }
    
    const handleFila = (e) => {
        setFila(e.target.value)
    }

    const handleChangeInput = (e) => {
        setCampanha(e.target.value)
    }

    const handleDelete = (e) => {
        setImagem(``)
        setNomeAnexo(``)
    }

    const handleSubmit = async () => {
        // let json = {
        //     id: cData.id,
        //     whatsappId: whats,
        //     queueId: fila,
        //     campanha: campanha,
        //     horarioInicial: tempoInicio,
        //     horarioFinal: tempoFinal,
        //     dataInicial: dataInicio,
        //     dataFinal: dataFinal,
        //     mensagem: msg
        // }
        var data = new FormData()
        data.append(`id`,cData.id)
        data.append(`whatsappId`,whats)
        data.append(`queueId`,fila)
        data.append(`campanha`,campanha)
        data.append(`horarioInicial`,tempoInicio)
        data.append(`horarioFinal`,tempoFinal)
        data.append(`dataInicial`,dataInicio)
        data.append(`dataFinal`,dataFinal)
        data.append(`mensagem`,msg)
        
        if (!imagem || imagem == undefined) {
            data.append("imagem", 0)
            data.append('nomeAnexo',``)
        } else {
            data.append("imagem", imagem)
            data.append('nomeAnexo',nomeAnexo)
        }
       let res = await api.post('/editarCampanha', data)
        if(res.status == 200) {
            toast.success(`Campanha editada com sucesso!`)
        }
        if (res.status == 400) {
            toast.error(`Erro ao editar a campanha!`)
        }
        handleClose()
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            classes={{paper: classes.paper}}
        >
            <DialogTitle>
                Editar Campanha
            </DialogTitle>
            <DialogContent dividers='true'>
                <Container>
                    <Container style={{ margin: '4px' }}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            // className={classes.txtMensagem}
                            fullWidth
                            id="nome"
                            value={campanha}
                            onChange={handleChangeInput}
                            label="Digite o nome da campanha..."
                            name="Nome"
                            autoComplete="Campanha"
                            autoFocus
                            className={classes.textField}
                        />
                    </Container>
                    <Container className={classes.ContentContainer}>
                        <InputLabel style={{ display: 'flex', margin: '4px' }}>Conexão</InputLabel>
                        <Select
                            autoWidth
                            native
                            label="Conexão Whatsapp"
                            style={{ display: 'flex', margin: '2px' }}
                            displayEmpty
                            defaultValue={whats}
                            value={whats}
                            onChange={e => handleWhats(e)}
                        >
                            <option value={0}> </option>
                            <>{whatsData.map(w => (
                                <option value={w.id}>{w.name}</option>
                            ))}</>
                        </Select>
                    </Container>
                    <Container className={classes.ContentContainer}>
                        <InputLabel style={{ display: 'flex', margin: '4px' }}>Fila</InputLabel>
                        <Select
                            autoWidth
                            native
                            label="Fila"
                            style={{ display: 'flex', margin: '2px' }}
                           // disabled={filaLocked}
                            defaultValue={fila}
                            value={fila}
                            onChange={e => handleFila(e)}
                        >
                            <option value={0}>Sem Fila</option>
                            <>{filasData.map(f => (
                                <option value={f.id}>{f.name}</option>
                            ))}</>
                        </Select>
                    </Container>
                    <Container className={classes.ContentContainer}>
                        <FormLabel style={{ display: 'flex', margin: '4px' }}>Horário</FormLabel >
                        <TextField
                            id="time"
                            label="Inicio"
                            type="time"
                            defaultValue={tempoInicio}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                step: 300, // 5 min
                            }}
                            style={{ width: 100, padding: `4px`, marginRight: `16%` }}
                            onChange={e => setTempoInicio(e.target.value)}
                            value={tempoInicio}
                        />
                        <TextField
                            id="time"
                            label="Fim"
                            type="time"
                            defaultValue={tempoFinal}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                step: 300, // 5 min
                            }}
                            style={{ width: 100, padding: `4px` }}
                            onChange={e => setTempoFinal(e.target.value)}
                            value={tempoFinal}
                        />
                    </Container>
                    <Container className={classes.ContentContainer}>
                        <FormLabel style={{ display: 'flex', margin: '4px' }}>Data</FormLabel >
                        <TextField
                            id="time"
                            label="Inicio"
                            type="date"
                            defaultValue={dataInicio}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                step: 300, // 5 min
                            }}
                            style={{width: 150, padding: `4px`, marginRight: `10%`}}
                            onChange={e => setDataInicio(e.target.value)}
                            value={dataInicio}
                        />
                        <TextField
                            id="time"
                            label="Fim"
                            type="date"
                            defaultValue={dataFinal}
                            value={dataFinal}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                step: 300, // 5 min
                            }}
                            style={{ width: 150, padding: `4px` }}
                            onChange={e => setDataFinal(e.target.value)}
                        />
                    </Container>
                    <Container className={classes.ContentContainer}>
                    <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            className={classes.txtMensagem}
                            fullWidth
                            multiline
                            minRows={3}
                            id="msg"
                            value={msg}
                            onChange={e => setMensagem(e.target.value)}
                            label="Digite sua mensagem..."
                            name="msg"
                            autoComplete="mensagem"
                            autoFocus
                        ></TextField>
                    </Container>
                    <Container className={classes.ContentContainer}>
                    <input style={{ display: 'none' }} id='inputFile' type="file" accept="image/*, video/*, audio/*" onChange={onSelectFile} />
                        <label htmlFor="inputFile">
                            <Button
                                variant="contained"
                                className={classes.btnUpload}
                                color="primary"
                                component="span"
                            >
                                Upload do anexo
                            </Button>
                        </label>
                    </Container>
                    <Container>
                    <Typography variant="subititle1" className={classes.wrapIcon}>
                    <AttachFile /> {nomeAnexo}
                    <IconButton
                                            size='small'
                                            onClick={handleDelete}
                                        >
                                            <Delete></Delete>
                        </IconButton>
                    </Typography>
                </Container>
                </Container>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={onClose}
                    color="secondary"
                    //disabled={isSubmitting}
                    variant="outlined"
                >
                    Sair
                </Button>
                <Button
                    onClick={handleSubmit}
                    color="primary"
                    //disabled={isSubmitting}
                    variant="contained"
                >
                    Editar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default EditCampanha